module.exports = __webpack_public_path__ + "static/img/smartstation42.e385f4a5.png";